export enum participantView {
	SINGLE = 'SINGLE',
	SUB_GROUP = 'SUB_GROUP',
}

export enum SignWaiverEnum {
	SIGNED = 'signed',
	UNSIGNED = 'unsigned',
}

export enum ParticipantsTabs {
	INDIVIDUALS = 'individuals',
	GROUPS = 'groups',
	CREATE_GROUP = 'create-group',
	WAITLIST = 'waitlist',
}
